const volume_of_closed_bsnss_per_yr_list = [
  {
    value: "less_than_500_000",
    name: "Less than $500,000",
  },
  {
    value: "500_000-999_999",
    name: "$500,000 - $999,999",
  },
  {
    value: "1_000_000-1_999_999",
    name: "$1,000,000 - $1,999,999",
  },
  {
    value: "over_2_000_000",
    name: "Over $2,000,000",
  },
];

export default volume_of_closed_bsnss_per_yr_list;



// WEBPACK FOOTER //
// ./src/constants/volume_of_closed_bsnss_per_yr_list.js